/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import { Button, Col, Form, Modal, notification, Row, Select, Typography } from 'antd';
import { connect } from 'react-redux';
import { get } from 'lodash';
import { addInterval, deleteInterval, updateInterval } from '../../redux/admin/intervals/action';
import ModalCustomSelect from '../common/ModalCustomSelect';

const { Option } = Select;
const { Text } = Typography;

const AddNewInterval = (props) => {
  const {
    setIntervalModalOpen,
    intervalmodalOpen,
    intervalModalText,
    intervalUpdate,
    intervalsList,
    intervalisDelete,
    intervalDropList,
    isModernPage = false,
  } = props;
  const {
    onAddInterval,
    isAddAdminIntervalLoading,
    isIntervalUpdateLoading,
    onUpdateInterval,
    onDeleteInterval,
    isIntervalDeleteLoading,
  } = props;

  const [checkIntervalForm] = Form.useForm();
  const [intervalText, setIntervalText] = useState('');
  const [intervalType, setIntervalType] = useState('');
  const [confirmDelete, setConfirmDelete] = useState(false);

  /** Waiting to Add interval and close Modal */
  useEffect(() => {
    if (!isAddAdminIntervalLoading) {
      setIntervalModalOpen(false);
      checkIntervalForm.resetFields();
      setIntervalText('');
      setIntervalType('');
      setConfirmDelete(false);
    }
  }, [isAddAdminIntervalLoading]);

  /** Waiting to Update interval and close Modal */
  useEffect(() => {
    if (!isIntervalUpdateLoading) {
      setIntervalModalOpen(false);
      checkIntervalForm.resetFields();
      setIntervalText('');
      setIntervalType('');
      setConfirmDelete(false);
    }
  }, [isIntervalUpdateLoading]);

  /** Waiting to Delete interval and close Modal */
  useEffect(() => {
    if (!isIntervalDeleteLoading) {
      setIntervalModalOpen(false);
      checkIntervalForm.resetFields();
      setIntervalText('');
      setIntervalType('');
      setConfirmDelete(false);
    }
  }, [isIntervalDeleteLoading]);

  /** Adding or Updating interval */
  const handleOk = () => {
    checkIntervalForm.validateFields().then(async (data) => {
      if (intervalUpdate) {
        if (data.intervalText && data.intervalType) {
          const typeId = intervalsList.find((u) => u.name === data.intervalType);
          var obj = {
            checkInterval: {
              name: data.intervalText,
            },
          };
          await onUpdateInterval({ data: obj, id: typeId.id });
        } else {
          notification.warning({
            message: 'Please Fill all the required Fields!',
          });
        }
      } else if (intervalisDelete) {
        if (data.intervalType) {
          const typeId = intervalsList.find((u) => u.name === data.intervalType);

          await onDeleteInterval({ id: typeId.id });
        } else {
          notification.warning({
            message: 'Please Select Interval to Delete!',
          });
        }
      } else {
        if (data.intervalText) {
          var obj = {
            checkInterval: {
              name: data.intervalText,
            },
          };

          await onAddInterval(obj);
        } else {
          notification.warning({
            message: 'Please enter the Interval to proceed!',
          });
        }
      }
    });
  };

  /** Resetting values on Closing Modal */
  const handleCancel = () => {
    setIntervalModalOpen(false);
    checkIntervalForm.resetFields();
    setIntervalText('');
    setIntervalType('');
    setConfirmDelete(false);
  };

  /** Setting the value on selecting interval */
  const onChangeInterval = (value) => {
    setIntervalType(value);
    setIntervalText(value);
    checkIntervalForm.setFieldsValue({ intervalText: value });
    setConfirmDelete(true);
  };

  const selectClassName = isModernPage ? 'heatprofile-maintenance-select' : 'client-select';
  /** Custom select portal z-index — must stay above Modal zIndex (5e6) */
  const MODAL_CUSTOM_SELECT_Z = 5000200;

  return (
    <div>
      <Modal
        width={isModernPage ? 520 : '45vw'}
        className={
          isModernPage ? 'heatprofile-modal pipeline-modal add-interval-modal' : 'pipeline-modal'
        }
        title={intervalModalText}
        centered
        visible={intervalmodalOpen}
        zIndex={isModernPage ? 5000000 : undefined}
        footer={[
          <Button
            key="cancel"
            onClick={handleCancel}
          >
            {'Cancel'}
          </Button>,
          <Button
            key="apply"
            type="primary"
            onClick={handleOk}
            loading={
              isAddAdminIntervalLoading || isIntervalUpdateLoading || isIntervalDeleteLoading
            }
          >
            {intervalUpdate
              ? isIntervalUpdateLoading
                ? 'Updating'
                : 'Update'
              : intervalisDelete
              ? isIntervalDeleteLoading
                ? 'Deleting'
                : 'Confirm'
              : isAddAdminIntervalLoading
              ? 'Adding'
              : 'Add'}
          </Button>,
        ]}
      >
        <Form
          form={checkIntervalForm}
          name="basic"
          layout="vertical"
          autoComplete="off"
          getContainer={false}
        >
          <Row gutter={isModernPage ? [16, 16] : 24}>
            {(intervalUpdate || intervalisDelete) && (
              <Col xs={24} lg={isModernPage ? 24 : intervalisDelete ? 16 : 18}>
                <Form.Item
                  label={intervalisDelete && 'Select Interval'}
                  name="intervalType"
                  required
                >
                  {isModernPage ? (
                    <ModalCustomSelect
                      className="heatprofile-interval-modal-select"
                      placeholder="Select Interval"
                      showSearch
                      dropdownZIndex={MODAL_CUSTOM_SELECT_Z}
                      options={(intervalsList || [])
                        .filter((item) => item && item.name)
                        .map((item, idx) => ({
                          key: item.id != null ? item.id : `interval-${item.name}-${idx}`,
                          value: item.name,
                          label: item.name,
                        }))}
                      onSelect={onChangeInterval}
                    />
                  ) : (
                    <Select
                      className={selectClassName}
                      placeholder="Select Interval"
                      showSearch
                      optionFilterProp="children"
                      onChange={onChangeInterval}
                      getPopupContainer={(triggerNode) => triggerNode.parentNode}
                    >
                      {intervalsList &&
                        intervalsList.map((item, i) => (
                          <Option
                            key={i}
                            value={item && item.name}
                          >
                            {item && item.name}
                          </Option>
                        ))}
                    </Select>
                  )}
                </Form.Item>
              </Col>
            )}
            {!intervalisDelete ? (
              <Col xs={24} lg={isModernPage ? 24 : 18}>
                <Form.Item
                  label="Select Interval"
                  name="intervalText"
                  required
                >
                  {/* <Input
                                        placeholder={intervalUpdate ? 'Edit selected Interval ' : 'Enter New Interval'}
                                        value={intervalText}
                                        onChange={(e) => setIntervalText(e.target.value)}
                                        size="large"
                                        disabled={intervalUpdate && !intervalType}
                                    /> */}
                  {isModernPage ? (
                    <ModalCustomSelect
                      className="heatprofile-interval-modal-select"
                      placeholder="Select Interval"
                      showSearch
                      parentOpen={intervalmodalOpen}
                      dropdownZIndex={MODAL_CUSTOM_SELECT_Z}
                      options={(intervalDropList || []).map((item, idx) => ({
                        key: item.id != null ? item.id : `drop-${item.name}-${idx}`,
                        value: item.name,
                        label: item.name,
                        disabled: !!(intervalsList || []).find((data) => data.name === item.name),
                      }))}
                      onSelect={(v) => setIntervalText(v)}
                    />
                  ) : (
                    <Select
                      className={selectClassName}
                      placeholder="Select Interval"
                      showSearch
                      onChange={(value) => setIntervalText(value)}
                      optionFilterProp="children"
                      getPopupContainer={(triggerNode) => triggerNode.parentNode}
                    >
                      {intervalDropList &&
                        intervalDropList.map((item, i) => (
                          <Option
                            key={i}
                            value={item && item.name}
                            disabled={intervalsList.find((data) => data.name === item.name)}
                          >
                            {item && item.name}
                          </Option>
                        ))}
                    </Select>
                  )}
                </Form.Item>
                <Text
                  style={
                    isModernPage
                      ? { fontSize: 13, color: '#6b7280', display: 'block', marginTop: 4 }
                      : { fontSize: '14px', color: 'orangered' }
                  }
                >
                  <b style={{ color: isModernPage ? '#00C9A7' : 'red' }}>*</b>Existed intervals
                  cannot be added.
                </Text>
              </Col>
            ) : (
              <Col xs={24}>
                <div
                  className={isModernPage ? 'equip-check-delete-body' : undefined}
                  style={isModernPage ? undefined : { padding: '0 16px' }}
                >
                  {confirmDelete && (
                    <Text
                      style={{
                        fontSize: isModernPage ? 15 : 16,
                        color: isModernPage ? '#374151' : undefined,
                      }}
                    >
                      <p style={isModernPage ? { marginBottom: 12 } : undefined}>
                        Deleting Interval will delete all the corresponding checks information.
                      </p>
                      Are you sure you want to delete{' '}
                      <b style={{ color: isModernPage ? '#00C9A7' : '#EF314C' }}>{intervalType}</b>{' '}
                      Interval?
                    </Text>
                  )}
                </div>
              </Col>
            )}
          </Row>
        </Form>
      </Modal>
    </div>
  );
};

const mapStateToProps = ({ checkIntervalReducer }) => {
  const isAddAdminIntervalLoading = get(checkIntervalReducer, 'isAddAdminIntervalLoading', false);
  const isIntervalUpdateLoading = get(checkIntervalReducer, 'isIntervalUpdateLoading', false);
  const isIntervalDeleteLoading = get(checkIntervalReducer, 'isIntervalDeleteLoading', false);
  return {
    isAddAdminIntervalLoading,
    isIntervalUpdateLoading,
    isIntervalDeleteLoading,
  };
};

const mapDispatchToProps = {
  onAddInterval: addInterval,
  onUpdateInterval: updateInterval,
  onDeleteInterval: deleteInterval,
};

export default connect(mapStateToProps, mapDispatchToProps)(AddNewInterval);
